
// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Angular/material
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

// Afidium
import { BookingsListComponent } from './bookings-list.component';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { BookingModule } from 'app_sasha/shared/components/booking/booking.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { BtnModule } from "libraries/ui_button/btn.module";
import { PermissionModule } from "libraries/permission/permission.module";
import {TdTextModule} from "libraries/component/table/td-text/td-text.module";
import {
    ConfigurableTableModule
} from "libraries/component/table/configurable-table/configurable-table.module";

@NgModule({
    imports: [
        CommonModule,
        MatListModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        FormsModule,
        NotificationModule,
        BookingModule,
        LoaderModule,
        BtnModule,
        PermissionModule,
        TdTextModule,
        ConfigurableTableModule,
    ],
    exports: [
        BookingsListComponent,
    ],
    declarations: [
        BookingsListComponent,
    ],
})
export class BookingsListModule { }
